import { useEffect, useState } from 'react'
import Spinner from 'app/components/Spinner'
import { bg } from 'lib/background'
import { run } from 'lib/run'
import { gqlFetchOne } from 'app/lib/graphqlClient'

const fetching: Record<string, Promise<string>> = {}
const cache: Record<string, string> = {}

export async function getName(workspaceId: string) {
  if (cache[workspaceId] != null) return cache[workspaceId]
  if (fetching[workspaceId] != null) return fetching[workspaceId]
  else if (!workspaceId || workspaceId === `undefined`) return
  return (fetching[workspaceId] = run(async () => {
    const ws = await gqlFetchOne<{ id: string; name: string }>('workspace', workspaceId, 'id name')
    return (cache[workspaceId] = ws?.name || `Unknown`)
  }))
}

export function LazyWorkspaceCell({ workspaceId }) {
  const [name, setName] = useState<string>(cache[workspaceId])
  useEffect(() => {
    if (name && cache[workspaceId] === name) return
    else setName(``)
    bg(
      getName(workspaceId).then((name) => {
        setName(name ?? ``)
      }),
    )
  }, [workspaceId])

  return name ? <span>{name}</span> : <Spinner size={5} />
}
